import { render, staticRenderFns } from "./surpriseForm.vue?vue&type=template&id=22c28d12&"
import script from "./surpriseForm.vue?vue&type=script&lang=js&"
export * from "./surpriseForm.vue?vue&type=script&lang=js&"
import style0 from "./surpriseForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports